export function calcHeightToFill(elementId: string, bottomPadding: number = 0, toSubtract: number = 0): string|null {
    const element = document.getElementById(elementId);
    if (!elementId || !element) return null;

    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const remainingHeight = viewportHeight - rect.top - bottomPadding - toSubtract;

    return `${Math.max(0, remainingHeight)}px`;
}
